import React from 'react';
import { Helmet } from 'react-helmet';

const jobList = [
  {
    title: "Java Developer",
    description: "We're looking for a skilled Java Developer to build and maintain high-performance backend applications.",
  },
  {
    title: "Python Developer",
    description: "We're looking for a Python Developer to build robust, scalable applications and automate backend processes.",
  },
  {
    title: "React.JS Developer",
    description: "We're looking for a React.JS Developer to create dynamic, responsive web applications using modern frontend technologies.",
  },
  {
    title: "UI/UX Designer",
    description: "We're looking for a UI/UX Designer to create intuitive, user-centered designs for web and mobile applications.",
  },
  {
    title: "SEO Marketing Manager",
    description: "We're looking for an experienced SEO marketing manager to join our team.",
  }
];

export default function CareersSection() {
  return (
    
    <section className="careers-section">
      {/* ✅ Helmet for SEO */}
      <Helmet>
        <title>Join Our Team | Careers at Pravisht Digital</title>
        <meta name="description" content="Explore exciting career opportunities at Pravisht Digital. Join our growing team of developers, designers, and marketers shaping the digital future." />
        <meta name="keywords" content="Careers at Pravisht, Job Openings, React Developer Jobs, UI UX Jobs, Java Developer Jobs, Digital Company Hiring" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Pravisht Digital" />
        <meta property="og:title" content="Careers at Pravisht | We're Hiring!" />
        <meta property="og:description" content="Explore job openings in development, design, SEO, and more at Pravisht Digital." />
        <meta property="og:image" content="/career_pravisht.jpg" />
        <meta property="og:url" content="https://www.pravisht.com/careers" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <div className="career-container">
        <div className="breadcrumb">
              {/* <a href="/">Home</a> &gt; <a href="#">Who We Are</a> &gt; <span>About Us</span> */}
               <a href="/">Home</a> &gt;  <span>Career</span>
           </div>

        <div className="about-heading-section">
            <h1>Be part of our mission</h1>
            <p>
            Pravisht's objective is to assist our customers in developing unique services and solutions while also assisting them in growing their businesses.
            </p>
        </div>
        <div className="about-image-fullscreen">
        <img src="/career_pravisht.jpg" alt="Pravisht Digital" />
        </div>
        <h2 className="subtitle">We’re hiring!</h2>
        {/* <p className="description">
          We’re looking for passionate people to join us on our mission. We value flat hierarchies,
          clear communication, and full ownership and responsibility.
        </p> */}

        <div className="tags">
          {[ 'Development', 'Design', 'Finance', 'Management'].map((tag) => (
            <button key={tag} className="tag-button">{tag}</button>
          ))}
        </div>

        <div className="job-list">
          {jobList.map((job) => (
            <div key={job.title} className="job-item">
              <div className="job-info">
                <h3 className="job-title">{job.title}</h3>
                <p className="job-desc">{job.description}</p>
                <div className="job-tags">
                  <span className="job-badge">100% Work From Office</span>
                  <span className="job-badge">Full-time</span>
                </div>
              </div>
              <div className="apply-link">
                <a href="#apply">Apply ↗</a>
              </div>
            </div>
          ))}
        </div>

        <div className="quote-section">
          <p className="quote">
            Pravisht truly values work-life balance. We work hard and deliver,
            but at the end of the day you can switch off.
          </p>
          {/* <div className="profile">
            <img
              src="https://randomuser.me/api/portraits/women/44.jpg"
              alt="Kundan Kumar"
              className="profile-pic"
            />
            <p className="profile-name">Kundan KUmar</p>
            <p className="profile-role">Web Developer, Pravisht</p>
          </div> */}
        </div>
      </div>
    </section>
  );
}
